import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { CustomProvider } from 'rsuite';
import LoginPage from 'Components/login/LoginPage';
import Main from 'Components/Main/Main';

import { FEXETable } from 'Components/DTE/FEXE/Table';
import { CCFETable } from 'Components/DTE/CCFE/Table';
import { CLETable } from 'Components/DTE/CLE/Table';
import { CRETable } from 'Components/DTE/CRE/Table';
import { DCLETable } from 'Components/DTE/DCLE/Table';
import { FETable } from 'Components/DTE/FE/Table';
import { NCETable } from 'Components/DTE/NCE/Table';
import { NDETable } from 'Components/DTE/NDE/Table';
import { NRETable } from 'Components/DTE/NRE/Table';
import { FSETable } from 'Components/DTE/FSE/Table';
import TableUser from 'Components/Admin/User/Users/TableUser';
import EmpresaTable from 'Components/Admin/Empresa/Empresas/EmpresaTable';
import CertificadosTable from 'Components/Admin/Certificado/Certificados/CertificadosTable';
import { FEXEDetail } from 'Components/DTE/FEXE/Detail';
import { FEDetail } from 'Components/DTE/FE/Detail';
import { CCFEDetail } from 'Components/DTE/CCFE/Detail';
import { DCLEDetail } from 'Components/DTE/DCLE/Detail';
import { CREDetail } from 'Components/DTE/CRE/Detail';
import { CLEDetail } from 'Components/DTE/CLE/Detail';
import { NDEDetail } from 'Components/DTE/NDE/Detail';
import { NCEDetail } from 'Components/DTE/NCE/Detail';
import { NREDetail } from 'Components/DTE/NRE/Detail';
import { FSEDetail } from 'Components/DTE/FSE/Detail';
import { Explorer } from 'Components/FileExplorer/Explorer';
import MisEmpresasTable from 'Components/Emisores/MisEmpresasTable';

function App() {
  const [isDark, setIsDark] = React.useState(false);

  React.useEffect(() => {
    const dm = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    setIsDark(dm);
  }, []);

  return (
    <CustomProvider theme={isDark ? 'dark' : 'light'}>
      <BrowserRouter>
        <Routes>
          {/* <Header /> */}
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/main"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          >
            <Route
              path={`users`}
              element={
                <ProtectedRoute>
                  <TableUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="empresas"
              element={
                <ProtectedRoute>
                  <EmpresaTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="misempresas"
              element={
                <ProtectedRoute>
                  <MisEmpresasTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="certificados"
              element={
                <ProtectedRoute>
                  <CertificadosTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="explorer"
              element={
                <ProtectedRoute>
                  <Explorer />
                </ProtectedRoute>
              }
            />
            <Route
              path="fe/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <FEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="fe/*"
              element={
                <ProtectedRoute>
                  <FETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="fexe/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <FEXEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="fexe/*"
              element={
                <ProtectedRoute>
                  <FEXETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="ccfe/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <CCFEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="ccfe/*"
              element={
                <ProtectedRoute>
                  <CCFETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="nre/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <NREDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="nre/*"
              element={
                <ProtectedRoute>
                  <NRETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="nce/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <NCEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="nce/*"
              element={
                <ProtectedRoute>
                  <NCETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="nde/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <NDEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="nde/*"
              element={
                <ProtectedRoute>
                  <NDETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="cle/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <CLEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="cle/*"
              element={
                <ProtectedRoute>
                  <CLETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="cre/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <CREDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="cre/*"
              element={
                <ProtectedRoute>
                  <CRETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="dcle/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <DCLEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="dcle/*"
              element={
                <ProtectedRoute>
                  <DCLETable />
                </ProtectedRoute>
              }
            />
            <Route
              path="fse/:codigoGeneracion"
              element={
                <ProtectedRoute>
                  <FSEDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="fse/*"
              element={
                <ProtectedRoute>
                  <FSETable />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </CustomProvider>
  );
}

export const ProtectedRoute = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  if (!authState.isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default App;
